var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useOkapiKy } from '@folio/stripes/core';
import { useMessages } from '../useMessages';
import { t } from '../../services';
import { downloadCSV } from './downloadCSV';
import { MESSAGE_DELAY, POLLING_DELAY } from './constants';
import { isSuccess, isFailed, isCancelled } from './helpers';
export var useCSVExportPolling = function (listName, clearStorage) {
    var ky = useOkapiKy();
    var _a = useMessages(), showSuccessMessage = _a.showSuccessMessage, showErrorMessage = _a.showErrorMessage;
    var poll = function (listID, exportId) {
        setTimeout(function () {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var _a, listId, status_1, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, ky.get("lists/".concat(listID, "/exports/").concat(exportId)).json()];
                        case 1:
                            _a = _b.sent(), listId = _a.listId, status_1 = _a.status;
                            if (isFailed(status_1)) {
                                showErrorMessage({
                                    timeout: 0,
                                    message: t('callout.list.csv-export.error', {
                                        listName: listName
                                    })
                                });
                            }
                            else if (isSuccess(status_1)) {
                                downloadCSV({
                                    ky: ky,
                                    listId: listId,
                                    exportId: exportId,
                                    listName: listName,
                                    onSuccess: function () {
                                        showSuccessMessage({
                                            timeout: MESSAGE_DELAY,
                                            message: t('callout.list.csv-export.success', {
                                                listName: listName
                                            })
                                        });
                                        clearStorage();
                                    },
                                    onError: function () {
                                        showErrorMessage({
                                            timeout: 0,
                                            message: t('callout.list.csv-export.error', {
                                                listName: listName
                                            })
                                        });
                                        clearStorage();
                                    },
                                });
                            }
                            else if (isCancelled(status_1)) {
                                // collapse recursion
                            }
                            else {
                                poll(listId, exportId);
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _b.sent();
                            if (error_1.name === 'TimeoutError') {
                                poll(listID, exportId);
                            }
                            else {
                                showErrorMessage({
                                    message: t('callout.list.csv-export.error', {
                                        listName: listName,
                                    }),
                                });
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
        }, POLLING_DELAY);
    };
    return poll;
};
